import { useState } from 'react';
import { useGetOne, useListContext, useTranslate } from 'react-admin';
import { Clear } from '@mui/icons-material';
import { Box, IconButton, Slider, Stack, Typography } from '@mui/material';

export const PriceFilterSlider = ({
	type,
	max
}: {
	type: string;
	max: number;
}) => {
	const translate = useTranslate();
	const { filterValues, setFilters } = useListContext();
	const { data: priceSummary, isPending } = useGetOne(
		'apartments_price_summary',
		{
			id: 'summary'
		}
	);
	const min = isPending ? 0 : priceSummary.rent_usd_object_price_min;
	max = isPending ? 0 : priceSummary.rent_usd_object_price_max;
	console.log('priceSummary', priceSummary);
	console.log('isPending', isPending);

	const marks = [
		{
			value: min,
			label: min
		},
		{
			value: max,
			label: max
		}
	];

	const [range, setRange] = useState([
		Number(filterValues[`${type}_usd_object_price@gte`] ?? min),
		Number(filterValues[`${type}_usd_object_price@lte`] ?? max)
	]);

	const updateFilters = (newRange: number[]) => {
		setRange(newRange);
		setFilters(
			{
				...filterValues,
				[`${type}_usd_object_price@gte`]: newRange[0],
				[`${type}_usd_object_price@lte`]: newRange[1]
			},
			{},
			true
		);
	};

	const handleSliderChange = (event: Event, newValue: number | number[]) => {
		if (!Array.isArray(newValue)) return;
		updateFilters(newValue);
	};

	const clearFilters = () => {
		setFilters({
			...filterValues,
			[`${type}_usd_object_price@gte`]: undefined,
			[`${type}_usd_object_price@lte`]: undefined
		});
		setRange([min, max]);
	};

	return (
		<Box>
			<Stack direction="row" justifyContent="space-between" alignItems="center">
				<Typography gutterBottom>
					{translate(`objects.filters.${type}Price`)} $
				</Typography>
				<IconButton onClick={clearFilters}>
					<Clear />
				</IconButton>
			</Stack>
			<Slider
				min={min !== max ? min : 0}
				max={max}
				value={range}
				onChange={handleSliderChange}
				valueLabelDisplay="auto"
				disableSwap={true}
				marks={marks}
			/>
		</Box>
	);
};
